module.exports = __webpack_public_path__ + "static/media/step3mobile.155350f9.png";